import React from 'react'
import { Box, Card, CardContent, Typography } from '../../../../components/mui/Core/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import Constants from '../../../../constants/en.json'
import { useTheme } from '../../../../components/mui/Styles/index'

function TemporaryPasswordExpired() {
  const theme = useTheme()
  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const messageContainerStyle = {
    marginTop: '12px',
    textAlign: 'center',
    width: '448px',
    height: '56px',
  }

  return (
    <Box sx={theme.soloContainer}>
      <Card className='soloCard'>
        <CardContent sx={contentStyle}>
          <FormHeading formHeader={Constants.temporaryPasswordExpired.HEADER} />
          <Box sx={messageContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.temporaryPasswordExpired.MESSAGE}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default TemporaryPasswordExpired
